export default function (value, symbol = '%', positiveSymbol = '') {
	const finiteValue = Number.isFinite(value) ? value : 0
	return `${finiteValue > 0 ? positiveSymbol : ''}${Math.round(finiteValue * 100)} ${symbol}`
}
